import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vam-namvbar',
  templateUrl: './vam-namvbar.component.html',
  styleUrls: ['./vam-namvbar.component.scss']
})
export class VamNamvbarComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
